<template>
  <div class="update-form-wrap">

    <div class="update-modal">

      <div class="update-form-header">
        <h4>Modifier le profil</h4>
        <button class="modal-close" @click="$emit('cancel')">✕</button>
      </div>

      <form @submit.prevent="submitForm" enctype="multipart/form-data" class="update-form">
      <div class="form-section">
        <div class="form-group">
          <label class="form-label">Poste</label>
          <select v-model="staff.Post_name" class="form-input" required>
            <option disabled value="">Sélectionner un poste</option>
            <option v-for="post in posts" :key="post.Post_name" :value="post.Post_name">{{ post.Post_name }}</option>
          </select>
        </div>

        <div class="form-group">
          <label class="form-label">Groupe horaire</label>
          <select v-model="staff.Group_name" class="form-input" required>
            <option disabled value="">Sélectionner un groupe horaire</option>
            <option v-for="group in workGroups" :key="group.group_name" :value="group.group_name">
              {{ group.group_name }} · {{ group.shift_start }} - {{ group.shift_end }}
            </option>
          </select>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Prénom</label>
            <input v-model="staff.First_name" type="text" class="form-input" required />
          </div>
          <div class="form-group">
            <label class="form-label">Nom</label>
            <input v-model="staff.Last_name" type="text" class="form-input" required />
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Date de début</label>
          <input v-model="staff.Created_at" type="date" class="form-input" required />
        </div>

        <div class="form-group">
          <label class="form-label">Statut</label>
          <select v-model.number="staff.Is_trial" class="form-input">
            <option :value="0">Direct</option>
            <option :value="1">Période d'essai</option>
          </select>
          <small v-if="originalIsTrial && staff.Is_trial === 0" class="salary-note">
            La confirmation applique le salaire depuis la date de début.
          </small>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">CIN</label>
            <input v-model="staff.Email" type="text" class="form-input" />
          </div>
          <div class="form-group">
            <label class="form-label">Téléphone</label>
            <input v-model="staff.Phone" type="tel" class="form-input" />
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Adresse</label>
          <input v-model="staff.Adress" type="text" class="form-input" />
        </div>

        <div class="form-group">
          <label class="form-label">{{ originalIsTrial && staff.Is_trial === 0 ? 'Salaire confirmé (MAD)' : 'Salaire de base (MAD)' }}</label>
          <input v-model="staff.Salary" type="number" min="0" step="1" class="form-input" :disabled="staff.Is_trial === 1" />
          <small v-if="staff.Is_trial === 1" class="salary-note">
            Aucun salaire n'est affecté tant que l'employé reste en période d'essai.
          </small>
        </div>

        <div class="form-group">
          <label class="form-label">Seuil avance semaine (MAD)</label>
          <input v-model="staff.Advance_weekly_limit" type="number" min="0" step="1" class="form-input" />
        </div>

        <div v-if="staff.Is_trial === 0 && !originalIsTrial" class="form-group">
          <label class="form-label">Date d'effet du salaire</label>
          <input v-model="staff.Salary_effective_from" type="date" class="form-input" :min="staff.Created_at" />
          <small class="salary-note">
            La date choisie décide à partir de quel jour le nouveau salaire sera calculé.
          </small>
        </div>

        <div class="form-group">
          <label class="form-label">Date d'effet du poste ou groupe</label>
          <input v-model="staff.Post_effective_from" type="date" class="form-input" />
          <small class="salary-note">
            Le changement s'applique à partir de cette date; les anciens jours gardent leur groupe horaire.
          </small>
        </div>

        <div class="form-group">
          <label class="form-label">Nouvelle photo</label>
          <div class="file-input-wrapper">
            <input type="file" id="pic-update" accept="image/*" @change="handleFileChange" class="file-input" />
            <label for="pic-update" class="file-label">
              {{ selectedFile ? selectedFile.name : 'Choisir une photo' }}
            </label>
          </div>
        </div>
      </div>

      <div v-if="success" class="alert alert-success">✓ Profil mis à jour!</div>
      <div v-if="error" class="alert alert-error">✕ {{ error }}</div>

      <div class="form-actions">
        <button type="button" @click="$emit('cancel')" class="btn btn-secondary">Annuler</button>
        <button type="submit" :disabled="loading" class="btn btn-primary">
          {{ loading ? 'Mise à jour...' : 'Enregistrer' }}
        </button>
      </div>
    </form>
  </div>
  </div>
</template>

<script>
export default {
    name: 'AppUpdateStaff',
    props: {
        staffData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            staff: {
                Id: this.staffData.Id,
                Post_name: this.staffData.Post_name,
                Group_name: this.staffData.GroupName || this.staffData.group_name || '',
                First_name: this.staffData.First_name,
                Last_name: this.staffData.Last_name,
                Pic: this.staffData.Pic,
                Email: this.staffData.Email,
                Adress: this.staffData.Adress,
                Phone: this.staffData.Phone,
                Salary: this.staffData.Salary,
                Is_trial: Number(this.staffData.IsTrial ?? this.staffData.Is_trial ?? this.staffData.is_trial ?? 0),
                Advance_weekly_limit: 0,
                Salary_effective_from: this.defaultSalaryEffectiveDate(),
                Post_effective_from: this.todayForInput(),
                Created_at: this.dateForInput(this.staffData.Created_at || this.staffData.created_at),
            },
            originalSalary: Number(this.staffData.Salary || 0),
            originalIsTrial: Number(this.staffData.IsTrial ?? this.staffData.Is_trial ?? this.staffData.is_trial ?? 0) === 1,
            loading: false,
            success: false,
            error: null,
            selectedFile: null,
            posts: [],
            workGroups: [],
        };
    },
    mounted() {
        this.fetchPosts()
        this.fetchGroups()
        this.fetchAdvanceThreshold()
    },
    methods: {
        todayForInput() {
            const now = new Date();
            const offsetMs = now.getTimezoneOffset() * 60000;
            return new Date(now.getTime() - offsetMs).toISOString().slice(0, 10);
        },
        dateForInput(value) {
            if (!value) return this.todayForInput();
            return String(value).replace(/\//g, '-').slice(0, 10);
        },
        defaultSalaryEffectiveDate() {
            return this.todayForInput();
        },
        isPreviousMonth(dateText) {
            return String(dateText || '').slice(0, 7) < this.todayForInput().slice(0, 7);
        },
        handleFileChange(event) {
            this.selectedFile = event.target.files[0];
        },
        async fetchAdvanceThreshold() {
            if (!this.staff.Id) return;
            try {
                const response = await fetch(`/api-pointage/advance-threshold?staff_id=${this.staff.Id}`, {
                    credentials: 'include',
                    cache: 'no-store',
                });
                if (!response.ok) return;
                const data = await response.json();
                this.staff.Advance_weekly_limit = Number(data.weekly_limit || 0);
            } catch (error) {
                this.staff.Advance_weekly_limit = 0;
            }
        },
        async submitForm() {
            if (this.staff.Is_trial === 1) {
                this.staff.Salary = 0;
            }
            if (this.originalIsTrial && this.staff.Is_trial === 0) {
                if (Number(this.staff.Salary || 0) <= 0) {
                    this.error = "Le salaire confirmé est obligatoire";
                    return;
                }
                this.staff.Salary_effective_from = this.staff.Created_at;
            } else if (Number(this.staff.Salary || 0) !== this.originalSalary) {
                if (!this.staff.Salary_effective_from) {
                    this.error = "La date d'effet du salaire est obligatoire";
                    return;
                }
                if (this.staff.Salary_effective_from < this.staff.Created_at) {
                    this.error = "La date d'effet ne peut pas être avant la date de début";
                    return;
                }
                if (this.isPreviousMonth(this.staff.Salary_effective_from)) {
                    const ok = confirm("Attention: cette date d'effet peut modifier un mois précédent. Continuer ?");
                    if (!ok) return;
                }
            }
            if (!confirm('Êtes-vous sûr de vouloir modifier cet employé ?')) {
                return;
            }

            this.error = null;
            this.success = false;
            this.loading = true;

            const formData = new FormData();
            for (const key in this.staff) {
                formData.append(key, this.staff[key]);
            }

            if (this.selectedFile) {
                if (this.selectedFile.size > 10 * 1024 * 1024) {
                    this.error = 'La photo est trop grande';
                    this.loading = false;
                    return;
                }
                const compressedBlob = await this.compressImage(this.selectedFile, 600, 0.7);
                formData.append('pic', compressedBlob, this.selectedFile.name);
            }

            try {
                const res = await fetch(`/api-pointage/updatestaff`, {
                    method: 'POST',
                    body: formData,
                });

                if (!res.ok) throw new Error('Modification échouée');
                this.success = true;
                setTimeout(() => {
                    this.$emit('updated');
                }, 800);
            } catch (err) {
                this.error = err.message;
            } finally {
                this.loading = false;
            }
        },
        async fetchPosts() {
            try {
                const response = await fetch(`/api-pointage/fetchposts`, {
                    credentials: 'include',
                    cache: 'no-store',
                });
                if (!response.ok) throw new Error('Failed to fetch');
                const data = await response.json();
                this.posts = Array.isArray(data) ? data : [];
            } catch (error) {
                console.error("Error fetching posts:", error);
                this.posts = [];
            }
        },
        async fetchGroups() {
            try {
                const response = await fetch(`/api-pointage/fetchgroups`, {
                    credentials: 'include',
                    cache: 'no-store',
                });
                if (!response.ok) throw new Error('Failed to fetch');
                const data = await response.json();
                this.workGroups = Array.isArray(data) ? data : [];
                if (!this.staff.Group_name && this.workGroups.length) {
                    this.staff.Group_name = this.workGroups[0].group_name;
                }
            } catch (error) {
                console.error("Error fetching groups:", error);
                this.workGroups = [];
            }
        },
        async compressImage(file, maxWidth, quality) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                const reader = new FileReader();

                reader.onload = (e) => {
                    img.src = e.target.result;
                };

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const scale = Math.min(1, maxWidth / img.width);
                    canvas.width = img.width * scale;
                    canvas.height = img.height * scale;

                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    canvas.toBlob((blob) => {
                        if (blob) resolve(blob);
                        else reject(new Error('Compression échouée'));
                    }, 'image/jpeg', quality);
                };

                reader.onerror = () => reject(new Error('Erreur chargement image'));
                reader.readAsDataURL(file);
            });
        }
    },
};
</script>

<style scoped>
.update-form-wrap {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  background: rgba(15, 23, 42, 0.62);
  backdrop-filter: blur(6px);
}

.update-modal {
  width: min(760px, calc(100vw - 36px));
  max-height: min(760px, calc(100vh - 36px));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.32);
}

.update-form-header {
  position: sticky;
  top: 0;
  z-index: 2;
  min-height: 66px;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #dbe3f1;
}

.update-form-header h4 {
  margin: 0;
  font-size: 18px;
  color: var(--gray-900);
}

.modal-close {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 8px;
  background: var(--gray-100);
  color: var(--gray-600);
  cursor: pointer;
  font-weight: 800;
}

.modal-close:hover {
  background: var(--danger-bg);
  color: var(--danger);
}

.update-form {
  padding: 18px 20px 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-section {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 16px;
}

.form-section > .form-group:first-child,
.form-section > .form-group:nth-child(3),
.form-section > .form-group:nth-child(5),
.form-section > .form-group:nth-child(6),
.form-section > .form-group:nth-child(7),
.form-section > .form-group:nth-child(8) {
  grid-column: 1 / -1;
}

.form-row {
  display: contents;
}

.form-input {
  min-height: 40px;
}

.salary-note {
  display: block;
  margin-top: 7px;
  color: var(--gray-500);
  font-size: 12px;
  font-weight: 700;
}

.file-label {
  min-height: 46px;
  border-radius: 8px;
}

.form-actions {
  position: sticky;
  bottom: 0;
  z-index: 2;
  margin: 0 -20px;
  padding: 14px 20px 18px;
  background: #fff;
  border-top: 1px solid #dbe3f1;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.form-actions .btn {
  min-height: 40px;
}

.form-actions .btn svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

@media (max-width: 680px) {
  .update-form-wrap {
    align-items: stretch;
    padding: 10px;
  }

  .update-modal {
    width: 100%;
    max-height: calc(100vh - 20px);
    border-radius: 10px;
  }

  .form-section {
    grid-template-columns: 1fr;
  }

  .form-section > .form-group:first-child,
  .form-section > .form-group:nth-child(3),
  .form-section > .form-group:nth-child(5),
  .form-section > .form-group:nth-child(6),
  .form-section > .form-group:nth-child(7),
  .form-section > .form-group:nth-child(8) {
    grid-column: auto;
  }

  .form-actions {
    padding: 12px 16px 14px;
  }

  .form-actions .btn {
    flex: 1;
    min-height: 42px;
    font-size: 13px;
  }
}
</style>
